import CampaignDetails from './campaignDetails';

export default CampaignDetails;
